import { findInArray, FindInArrayResult } from 'owa-calendar-data-utils/lib/findInArray';
import { getStore } from '../store/store';
import { Calendar } from 'owa-calendar-cache';

export function findSelectedCalendar(calendarId: string): FindInArrayResult<Calendar> {
    return findInArray(getStore().selectedCalendars, cal => !!cal.id && cal.id.id == calendarId);
}

export function findCalendar(calendarId: string): Calendar {
    let calendars = getStore().calendars.filter(cal => !!cal.id && cal.id.id == calendarId);
    return calendars.length > 0 ? calendars[0] : null;
}
